import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { transformFormInput } from 'src/app/utils/string-util';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-employee-registration-form',
  templateUrl: './employee-registration-form.component.html',
  styleUrls: ['./employee-registration-form.component.scss'],
})
export class EmployeeRegistrationFormComponent implements OnInit {
  @ViewChild('EmployeeDetailsSavedDialog', { static: true })
  employeeDetailsSavedDialog: TemplateRef<any>;
  @ViewChild('EmployeeAlreadyExistsDialog', { static: true })
  employeeAlreadyExistsDialog: TemplateRef<any>;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  uploadProgressId = 0;
  uploadProgressProfile = 0;
  urlProfile: any;
  urlID: any;
  isUploadedNewImage = false;
  urlProfileFile: any;
  urlIdFile: any;
  profilePicture: string = '';
  identityId: string = '';
  orgId = '';
  employeeForm = this.formbuilder.group({
    orgID: [],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: [undefined, Validators.required],
    employeeAddress: ['', Validators.required],
    employeeDepartment: ['', Validators.required],
    employeeId: [],
    identityID: [''],
    profilePicture: [''],
    employeeDescriptors: [''],
  });
  isRetry: boolean = false;
  faceMatchMsg: string = null;
  isAPIRequest: boolean = false;
  showMsg: boolean;
  isFaceMatched: boolean;
  isSaveRequest: boolean;
  baseServerURL = environment.apiUrl;
  constructor(
    private screen: AumyeResponsiveScreenService,
    private formbuilder: FormBuilder,
    private activeRoute: ActivatedRoute,
    private httpclient: HttpClient,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.orgId = params['orgId'];
      if (this.orgId) {
        this.employeeForm.controls.orgID.setValue(this.orgId);
      }
    });
  }
  ngOnInit(): void {
    this.employeeForm.controls.firstName.disable();
    this.employeeForm.controls.lastName.disable();
    this.employeeForm.controls.email.disable();
    this.employeeForm.controls.phoneNumber.disable();
    this.employeeForm.controls.employeeAddress.disable();
    this.employeeForm.controls.employeeDepartment.disable();
    this.employeeForm.controls.employeeId.disable();
  }
  onUploadProfile(event: any) {
    this.isUploadedNewImage = true;
    this.urlProfileFile = event.target.files[0];
    const file = (event.target as HTMLInputElement).files?.[0];
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        const loadedBytes = (event.loaded as number) || 0;
        const totalBytes = file.size;
        this.uploadProgressProfile = Math.round(
          (loadedBytes / totalBytes) * 100
        );
        this.urlProfile = event.target.result;
        this.profilePicture = ' Profile Added';
      };
    }
  }
  onUploadID(event: any) {
    this.isUploadedNewImage = true;
    this.urlIdFile = event.target.files[0];
    const file = (event.target as HTMLInputElement).files?.[0];
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        const loadedBytes = (event.loaded as number) || 0;
        const totalBytes = file.size;
        this.uploadProgressId = Math.round((loadedBytes / totalBytes) * 100);
        this.urlID = event.target.result;
        this.identityId = 'ID Added';
      };
    }
  }
  transformInput(control: AbstractControl): void {
    transformFormInput(control);
  }
  onChangeNumber(val: any) {
    // console.log(val);
  }
  onSelfVerifyEmployee() {
    this.showMsg = true;
    this.isAPIRequest = true;
    let baseServerURL = this.baseServerURL+'MatchFaceRecognition';
    const formData = new FormData();
    formData.append('Identity', this.urlIdFile, this.urlIdFile.name);
    formData.append('Profile', this.urlProfileFile, this.urlProfileFile.file);
    this.httpclient.post(baseServerURL, formData).subscribe(
      (res: any) => {
        this.isFaceMatched = true;
        this.isAPIRequest = false;
        this.faceMatchMsg = 'Face Matched';
        this.employeeForm.controls.firstName.enable();
        this.employeeForm.controls.lastName.enable();
        this.employeeForm.controls.email.enable();
        this.employeeForm.controls.phoneNumber.enable();
        this.employeeForm.controls.employeeAddress.enable();
        this.employeeForm.controls.employeeDepartment.enable();
        this.employeeForm.controls.employeeId.enable();
        this.employeeForm.controls.profilePicture.enable();
        this.employeeForm.controls.identityID.enable();
        this.employeeForm.controls.profilePicture.setValue(res.ProfilePhoto);
        this.employeeForm.controls.identityID.setValue(res.IdentityId);
        // this.enrollEmployeeFromImage(this.urlProfile);
      },
      (err) => {
        this.isFaceMatched = false;
        this.isRetry = true;
        this.faceMatchMsg = err.error;
        this.isAPIRequest = false;
      }
    );
  }
  onSaveEmployeeInformation() {
    this.isSaveRequest = true;
    let baseServerURL = this.baseServerURL+'AddEmployee';
    this.httpclient
      .post(baseServerURL, this.employeeForm.value, {
        responseType: 'text',
      })
      .subscribe(
        (res) => {
          this.isSaveRequest = false;
          this.openSavedDialog();
        },
        (err) => {
          this.dialog.open(this.employeeAlreadyExistsDialog, {
            disableClose: true,
          });
          this.isSaveRequest = false;
        }
      );
  }
  openSavedDialog() {
    this.toastr.success('Details Success', 'Employee Registration', {
      closeButton: true,
      timeOut: 10000,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
    const dialogRef = this.dialog.open(this.employeeDetailsSavedDialog, {
      disableClose: true,
    });
    setTimeout(() => {
      window.close();
    }, 10000);
  }
}
